const PinMapPlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M5.39648 6.4165H8.60482"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 8.02083V4.8125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.11231 4.95234C3.26148 -0.099328 10.7456 -0.0934946 11.889 4.95817C12.5598 7.92151 10.7165 10.4298 9.10064 11.9815C7.92814 13.1132 6.07314 13.1132 4.89481 11.9815C3.28481 10.4298 1.44148 7.91567 2.11231 4.95234Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PinMapPlusIcon;
